import { render } from "./MiscDemo.vue?vue&type=template&id=0bb04666"
import script from "./MiscDemo.vue?vue&type=script&lang=js"
export * from "./MiscDemo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__